import { useMemo } from 'react'
import { Source, Layer } from 'react-map-gl/maplibre'
import * as turf from '@turf/turf'
import { SensorResponse } from '@/api/v1/sensor-api'

const CircleLayer = ({ sensor }: { sensor: SensorResponse }) => {
    // Generate a circle polygon with a 1km radius, using 64 steps for smoothness.
    const circleFeature = useMemo(() => {
        if (!sensor.longitude || !sensor.latitude) return null;
        // Center of the circle [lng, lat]
        const center = [sensor.longitude, sensor.latitude];
        return turf.circle(center, 1, { steps: 64, units: 'kilometers' });
    }, [sensor.longitude, sensor.latitude]);

    if (!sensor.longitude || !sensor.latitude || !circleFeature) return null;

    const geojson: GeoJSON.FeatureCollection<GeoJSON.Geometry> = {
        type: 'FeatureCollection',
        features: [circleFeature],
    }

    // Define the style for the circle layer.
    const sensorId = sensor.slug || sensor.organisation_id.toString();
    const layerStyle = {
        id: `circle-${sensorId}`,
        type: 'fill' as const,
        paint: {
            'fill-color': '#088',
            'fill-opacity': 0.2,
            'fill-outline-color': '#088',
        },
    }

    return (
        <Source id={`source-${sensorId}`} type="geojson" data={geojson}>
            <Layer {...layerStyle} />
        </Source>
    )
}

export default CircleLayer
